// I guess this is for just random utility functions

// https://stackoverflow.com/a/55387306
// This is like Array.join() but for any types. `interleave` does it with a fixed value, `interleaveFunc` takes a function that
// will dynamically generate it from the index
export const interleaveFunc = <ArrayType, InterleaveType>(arr: ArrayType[], func: (i: number) => InterleaveType) =>
  ([] as (ArrayType | InterleaveType)[]).concat(...arr.map((n, i) => [n, func(i)])).slice(0, -1);

// See above.
// Example:
// console.log(interleave([1, 2, 3], "a"))
//    -> [1, "a", 2, "a", 3]
export const interleave = <ArrayType, InterleaveValue>(arr: ArrayType[], value: InterleaveValue) =>
  interleaveFunc(arr, () => value);
